/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiAccountsAiApiKeyUpdateParams = zod.strictObject({
    format: zod.enum(['csv', 'json']).optional(),
});

export type ApiAccountsAiApiKeyUpdateParams = zod.input<
    typeof ApiAccountsAiApiKeyUpdateParams
>;
export type ApiAccountsAiApiKeyUpdateParamsOutput = zod.output<
    typeof ApiAccountsAiApiKeyUpdateParams
>;
